<template>

    <div class="profile-photo" id="profile_photo">
        <div class="profile-photo__wrapper" @click="onLogoutClick">
            <img alt="Profile photo" src="@/assets/icons/ic_profile_gray.svg">
        </div>
        <div class="logout__wrapper" id="logout__wrapper">
            <div class="logout__text dropdown_item" @click="logout" v-if="accessToken">
                {{translate('Logout')}}
            </div>
            <div class="logout__text dropdown_item" @click="onAdminClick" v-if="showAdminMenu">
                Admin
            </div>
            <div class="logout__text dropdown_item"
                 v-for="(item, index) in settings.items"
                 @click="onItemClick(item)">
                {{ item.title }}
            </div>
        </div>
    </div>

</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import logAnalyticsEvent from '@/helpers/analytics';
    import config from '@/api/config';
    import $ from 'jquery';
    import rateMixin from "@/mixins/rateMixin";

    export default {
        name: 'profileIconNew',
        mixins: [rateMixin],

        data() {
            return {
                langShow: false,
                langSelect: this.$ml.current,
                toggleCheck: false,
                question_id: this.$route.params.questionId,
                profileIconTouchTime: 0,
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {
                        longTapForLogout: false,
                    }
                }
            },
        },

        mounted() {

        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
                accessToken: state => state.auth.accessToken,
            }),
            ...mapGetters({
                giveaway: 'rate/getGiveaway',
            }),
            showAdminMenu() {
                if(this.settings && this.settings.showAdminMenu != null) {
                    return this.settings.showAdminMenu
                } else {
                    return true
                }
            },
        },
        methods: {
            ...mapActions({
                logoutRemote: 'auth/logout',
            }),
            ...mapMutations({
                removeKeys: 'auth/removeKeys',
            }),

            onProfileIconClick() {
                this.toggleContent()
            },

            toggleContent() {
                this.toggleCheck = !this.toggleCheck;
                if (this.toggleCheck) {
                    $("#logout__wrapper").slideDown();
                    this.addDocumentMousUpListenerForToogleContent()
                } else {
                    $("#logout__wrapper").slideUp();
                }
            },

            addDocumentMousUpListenerForToogleContent() {
                let thiz = this
                $(document).one('mouseup', function (e) {
                    if ($("#profile_photo").has(e.target).length === 0 && $("#logout__wrapper").has(e.target).length === 0) {
                        thiz.toggleContent()
                    }
                });
            },

            async logout() {
                logAnalyticsEvent('vote_screen_logout_click')
                try {
                    await this.logoutRemote()
                } catch (error) {
                    console.log('error', error)
                } finally {
                    this.removeKeys()
                    this.$store.commit('owner/setOwner', false)
                    if (this.settings.afterLogoutHandler) {
                        try {
                            await this.settings.afterLogoutHandler(this.settings)
                        } catch (error) {
                            this.showErrorModal(error.message)
                        }
                    } else {
                        this.navigateToVoteLogin(this.question_id, this.$route.query.rate_uid, this.$route.query.rate_value)
                    }
                }
            },

            onAdminClick() {
                window.location.href =`${location.origin}/questions/${this.$route.params.questionId}/manage?is_sr=true`
            },
            onItemClick(item) {
                if(item.type == 'sr') {
                    window.location.href =`${location.origin}/questions/${this.$route.params.questionId}/service/${item.value}`
                } else if(item.type == 'admin') {
                    window.location.href =`${location.origin}/questions/${this.$route.params.questionId}/manage?is_sr=true`
                }
            },

        isServiceLog() {
            return this.$route.query.is_sl == 'true'
        },

            changeScreen() {
                let rateUid = this.$route.query.rate_uid
                let rateValue = this.$route.query.rate_value
                if(rateUid != null && rateValue != null && !this.isServiceLog()) {
                    this.navigateTo(`${location.origin}/r/thank-for-vote/${this.question_id}/${rateValue}/${rateUid}?from_manage=true`)
                } else {
                    this.navigateTo(`${location.origin}/r/rate/${this.question_id}/3?from_manage=true`)
                }
            },

            navigateTo(url) {
                window.location.replace(url)
            },

            onLogoutClick() {
                this.toggleContent()
            },

        },

    }
</script>

<style scoped>
    .profile-photo {
        position: relative;
        top: 20px;
        right: 20px;
        height: 40px;
        width: 40px;
        border-radius: 5px;
    }

    .profile-photo:hover {
        cursor: pointer;
    }

    .profile-photo img {
        border-radius: 50%;
        height: 40px;
        width: 40px;
        min-height: 40px;
        max-height: 40px;
    }

    .profile-photo__wrapper {
        position: relative;
        z-index: 1000;
    }

    .logout__wrapper {
        position: absolute;
        top: 50px;
        left: -150px;
        border-radius: 4px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 11px 0 rgba(0, 0, 0, 0.11);
        width: 190px;
        display: none;
    }
    .change-screen__wrapper {
        position: absolute;
        top: 0;
        max-height: 40px;
        min-height: 40px;
        right: 16px;
        background: #C4C4C4;
        border-radius: 18px 0px 0px 18px;
        color: white;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        padding: 0px 28px 0px 12px;
        z-index: 999;
        display: flex;
        align-items: center;
    }
    .dropdown_item {
        min-height: 45px;
        align-items: center;
        display: flex;
        padding: 4px 4px 4px 12px;
    }

</style>
